// Config UI constants and small pure helpers.

// Business statuses (§0.2). H has no ads; A is ignored by engines.
export const ALL_STATUSES = ['Y', 'T', 'H', 'D', 'L'];

// Sub-key domain per parameter. Only Y/T carry a TACOS ceiling (Law 3); DOC
// bands drive the Y/T stock cap. Both are limited to the ad-status world.
export const SUB_KEY_OPTIONS = {
  K2: ['Y', 'T'],
  P4: ['Y', 'T'],
};

// Override tiers below global, narrowest first (matches resolution precedence).
export const OVERRIDE_TIERS = ['dc', 'design', 'category'];

export const TIER_LABEL = {
  dc: 'DC',
  design: 'Design',
  category: 'Category',
  global: 'Global',
  factory: 'Factory default',
};

export const FAMILY_META = {
  strategic: { title: 'Strategic Six', note: 'The knobs you turn to steer the business.' },
  set_once: { title: 'Set-once facts (P-block)', note: 'Structural settings — change rarely.' },
  internal: {
    title: 'Engine Internals',
    note: 'Touch only on feedback evidence.',
  },
};

// The editable field template for one value of a parameter. For sub-keyed
// params the per-status value has the same shape, so we read the template from
// one sub-value of the factory default.
export function valueTemplate(param) {
  const dv = param.default_value;
  if (param.sub_key_kind) {
    const first = dv && typeof dv === 'object' ? Object.values(dv)[0] : null;
    return first ?? { value: null };
  }
  return dv ?? { value: null };
}

// Infer the input kind for a field from its key + template value.
export function fieldKind(key, templateValue) {
  if (key === 'style') return 'style';
  if (/window|_start$|_end$|date/.test(key)) return 'date';
  if (typeof templateValue === 'boolean') return 'bool';
  return 'number';
}

// Human-readable one-line rendering of a value object.
export function formatValue(value) {
  if (value == null) return '—';
  if (typeof value !== 'object') return String(value);
  const keys = Object.keys(value);
  if (keys.length === 1 && keys[0] === 'value') {
    return value.value == null ? '(unset)' : String(value.value);
  }
  return keys.map((k) => `${k}: ${value[k] == null ? '—' : value[k]}`).join(' · ');
}
